import React, { useState } from 'react';
import Icon from './Icon';
import Button from './Button';

const filterInputStyle = {
  width: '100%',
  padding: '9px 12px',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  fontSize: '13px',
  color: '#1e293b',
  background: '#ffffff',
  outline: 'none',
  boxSizing: 'border-box',
};

export const FilterField = ({ label, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
    {label && (
      <label style={{ fontSize: '12px', fontWeight: 600, color: '#64748b', letterSpacing: '0.02em' }}>
        {label}
      </label>
    )}
    {children}
  </div>
);

export const filterInputProps = { style: filterInputStyle };

const CollapsibleFilterPanel = ({
  title = 'Filters',
  defaultOpen = false,
  activeCount = 0,
  activeFilters = [],
  onReset,
  onSearch,
  searchLoading = false,
  gridColumns,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      className={`collapsible-filter-panel${open ? ' is-open' : ''}`}
      style={{
        background: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        overflow: 'visible',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
        position: 'relative',
        zIndex: open ? 12 : 1,
      }}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '14px 16px',
          background: open ? '#fafbfc' : '#ffffff',
          border: 'none',
          cursor: 'pointer',
          borderBottom: open ? '1px solid #e2e8f0' : 'none',
          transition: 'background 0.15s',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '8px',
              background: activeCount > 0 ? '#eef2ff' : '#f1f5f9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: activeCount > 0 ? '#667eea' : '#64748b',
            }}
          >
            <Icon name="filter" size={16} />
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '14px', fontWeight: 700, color: '#1e293b' }}>{title}</div>
            {!open && activeCount > 0 && (
              <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>
                {activeCount} filter{activeCount !== 1 ? 's' : ''} applied
              </div>
            )}
          </div>
          {activeCount > 0 && (
            <span
              style={{
                fontSize: '11px',
                fontWeight: 700,
                padding: '2px 8px',
                borderRadius: '10px',
                background: '#667eea',
                color: '#ffffff',
              }}
            >
              {activeCount}
            </span>
          )}
        </div>
        <Icon name={open ? 'chevUp' : 'chev'} size={18} color="#64748b" />
      </button>

      {!open && activeFilters.length > 0 && (
        <div
          style={{
            padding: '10px 16px 14px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            borderTop: '1px solid #f1f5f9',
          }}
        >
          {activeFilters.map((chip) => (
            <span
              key={chip.key}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '4px 10px',
                borderRadius: '20px',
                background: '#f1f5f9',
                fontSize: '12px',
                color: '#475569',
                fontWeight: 500,
              }}
            >
              <span style={{ color: '#94a3b8' }}>{chip.label}:</span>
              {chip.value}
              {chip.onClear && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    chip.onClear();
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    color: '#94a3b8',
                    display: 'flex',
                    lineHeight: 1,
                  }}
                >
                  <Icon name="x" size={12} />
                </button>
              )}
            </span>
          ))}
        </div>
      )}

      {open && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSearch?.(e);
          }}
          style={{ padding: '16px' }}
        >
          <div
            className="filter-panel-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: gridColumns
                ? `repeat(${gridColumns}, minmax(0, 1fr))`
                : 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: '14px',
            }}
          >
            {children}
          </div>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              justifyContent: 'flex-end',
              marginTop: '16px',
              paddingTop: '16px',
              borderTop: '1px solid #f1f5f9',
            }}
          >
            <Button type="button" variant="secondary" size="sm" onClick={onReset}>
              Reset
            </Button>
            <Button type="submit" size="sm" loading={searchLoading}>
              Apply Filters
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CollapsibleFilterPanel;
